import { DeleteIcon, MenuItem, red } from "@flat-ui";
import { SdbProject } from "@custom-types/project-types";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { useState } from "react";
import { Snapshot } from "@custom-types/base-types";
import { DeleteSnapshot } from "@pages/project-details/project-snapshots/delete-snapshot";

interface DeleteProjectProps {
  /** The type project is needed to manage the delete operation specific for project */
  type: "project";

  /** The project to be deleted */
  entity: SdbProject;
}

interface DeleteSnapshotProps {
  /** The type snapshot is needed to manage the delete operation specific for snapshot */
  type: "snapshot";

  /** The snapshot to be deleted */
  entity: Snapshot;
}

/** Renders a red "Delete" menu item and manages the delete confirmation dialog */
export function DeleteMenuItem(
  props: DeleteProjectProps | DeleteSnapshotProps
): JSX.Element {
  const [shouldShowDeleteDialog, setShouldShowDeleteDialog] =
    useState<boolean>(false);

  return (
    <>
      <MenuItem
        label="Delete"
        Icon={DeleteIcon}
        color={red[500]}
        highlightColor={red[500]}
        onClick={() => {
          setShouldShowDeleteDialog(true);
        }}
      />
      {shouldShowDeleteDialog &&
        (props.type === "project" ? (
          <DeleteProject
            project={props.entity}
            onClose={() => {
              setShouldShowDeleteDialog(false);
            }}
          />
        ) : (
          <DeleteSnapshot
            snapshot={props.entity}
            onClose={() => {
              setShouldShowDeleteDialog(false);
            }}
          />
        ))}
    </>
  );
}
